export default __webpack_public_path__ + "locales/subs.kk.json";